<template>
  <div class="grid-view">
    <div v-show="!isShow" class="main-content">
      <div class="section operations triggers" style="height: 39px;">
        <div>
          <el-button type="primary" :disabled="banned === 0" size="mini" @click="buttonDetails">{{ $t('Clearing.ViewDetails') }}</el-button>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="20220607"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="41001220014"
          :total="filter.total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="toQuery"
        />
      </div>
    </div>
    <div v-show="isShow" class="main-content historical-details">
      <div class="section operations triggers">
        <div>
          <el-button type="primary" size="mini" @click="toList">{{ $t('Clearing.Return') }}</el-button>
        </div>
        <div class="footer-check">
          <el-checkbox-group v-model="checkList" @change="statusChanges">
            <el-checkbox label="0">{{ $t('Clearing.ShowAllReconciliationFees') }}</el-checkbox>
            <el-checkbox label="1">{{ $t('Clearing.ShowFullyReconciledFees') }}</el-checkbox>
            <el-checkbox label="2">{{ $t('Clearing.ShowPartiallyReconciledFees') }}</el-checkbox>
            <el-checkbox label="3">{{ $t('Clearing.ShowUnmatchedFees') }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <p class="instructions section">
        {{ $t('Clearing.Note') }}
        <span style="color:green;">{{ $t('Clearing.Green') }}</span>{{ $t('Clearing.IndicatesReconciliationResultIsConsistent') }}
        <span style="color:#000;">{{ $t('Clearing.Black') }}</span>{{ $t('Clearing.IndicatesCorrespondingFeeNotFound') }}
        <span style="color:red;">{{ $t('Clearing.Red') }}</span>{{ $t('Clearing.IndicatesAmountInconsistency') }}
        <span style="color:orange;">{{ $t('Clearing.Orange') }}</span>{{ $t('Clearing.IndicatesManualReconciliationCompleted') }}
      </p>
      <div class="details-list grid-wrapper">
        <div class="details-content grid-wrapper">
          <div class="left">
            <p>{{ $t('Clearing.ImportExternalFees') }}</p>
            <cargo-ag-grid
              config-module="2022061601"
              :grid-options="externalGridOptions"
              :column-defs="externalColumnDefs"
              :row-data="externalData"
            />
            <!-- 分页 -->
            <div class="uniform">
              <div>
                <cargo-pagination
                  config-module="41001220015"
                  :total="externalPaging.total"
                  :page.sync="externalPaging.pageNum"
                  :limit.sync="externalPaging.pageSize"
                  @pagination="checkDetails()"
                />
              </div>
              <div v-show="externalPaging.total !== 0" class="combined">
                <p v-for="(item, index) in externalAmountList" :key="index" class="usd">
                  共{{ item.total }}笔，
                  <span style="font-weight: bold;">{{ item.currency }}：</span>
                  <span style="font-style: oblique;">{{ item.amount.toFixed(2) }}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="right">
            <p>{{ $t('Clearing.SystemInternalFees') }}</p>
            <cargo-ag-grid
              config-module="2022061602"
              :grid-options="internalGridOptions"
              :column-defs="internalColumnDefs"
              :row-data="internalData"
            />
            <!-- 分页 -->
            <div class="uniform">
              <div>
                <cargo-pagination
                  config-module="41001220016"
                  :total="internalPaging.total"
                  :page.sync="internalPaging.pageNum"
                  :limit.sync="internalPaging.pageSize"
                  @pagination="checkDetails()"
                />
              </div>
              <div v-show="internalPaging.total !== 0" class="combined">
                <p v-for="(item, index) in internalAmountList" :key="index" class="usd">
                  共{{ item.total }}笔，
                  <span style="font-weight: bold;">{{ item.currency }}：</span>
                  <span style="font-style: oblique;">{{ item.amount.toFixed(2) }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { getToken } from '@/utils/auth'
import { historyList, queryByreconciliationHistoryUuid } from '@/api/clearing/automaticReconciliation'
import { cache, cacheName } from '@/utils/cacheManager'
import { getGridSelected } from '@/utils/agGrid'
import { BuriedPointUtils } from '@/utils/BuriedPointUtils'
import { DocumentManage } from '@/utils/commonUtil'

export default {
  name: 'TabAutomaticReconciliationHistory',
  components: {
    searchItem
  },
  data() {
    return {
      // matchCondition: '',
      currentSessionId: getToken(),
      documentManage: new DocumentManage(),
      URL,
      banned: 0,
      isChecked: false,
      isAdvancedQuery: false, // 是否为高级查询
      externalTotalAmount: 0,
      internalTotalAmount: 0,
      isShow: false,
      checkList: ['0'],
      externalPaging: {
        total: 0,
        pageNum: 1,
        pageSize: 100
      },
      internalPaging: {
        total: 0,
        pageNum: 1,
        pageSize: 100
      },
      checkedId: '0',
      rowData: [],
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      storageURL: null,
      gridApi: null,
      filterJson: {},
      fullscreenLoading: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onSelectionChanged: this.changed,
        onRowDoubleClicked: params => {
          this.doubleDetails(params)
        },
        onRowClicked: (params) => {
          if (params.data) {
            this.banned = 1
          }
          this.selectedRows = params.data
        }
      },
      selectedRows: {},
      gridParams: {},
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SettlementCompany'),
          field: 'accountId',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.ImportTime'), field: 'dateCreated', colId: 'dateCreated', width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Payment.operator'), field: 'createdBy', colId: 'createdBy', width: 200,
          cellRenderer: (params) => {
            const username = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            return username === '' ? this.$t('Clearing.System') : username
          }
        },
        {
          headerName: this.$t('SeaExport.importFile'),
          field: 'importFileId', colId: 'importFileId',
          width: 300,
          cellRenderer: params => {
            const methodOnFileViewPath = this.documentManage.getPath('onFileView')
            return `<a href="javascript:void(0)" onclick="${methodOnFileViewPath}('${params.value},${1}')" style="color:#46a6ff">查看文件</a>`
          }
        },
        {
          headerName: this.$t('SeaExport.logFile'), field: 'resultFileId', colId: 'resultFileId', width: 150, noExport: true,
          cellRenderer: (params) => {
            const methodOnFileViewPath = this.documentManage.getPath('onFileView')
            return `<a href="javascript:void(0)" onclick="${methodOnFileViewPath}('${params.value},${2}')" style="color:#46a6ff">查看文件</a>`
          }
        },
        {
          headerName: this.$t('CargoMsg.ReconciliationResult'), field: 'result', colId: 'result', width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AdjustmentExpenseState'),
          field: 'reconciliationAdjustState',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.reconciliationAdjustStateLabelFunc(params.value)
          },
          cellStyle: (params) => {
            return this.setColor(params)
          }
        }
      ],
      externalAmountList: [], // 外部币种金额分类合计
      internalAmountList: [], // 内部币种金额分类合计
      externalGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        paginationPageSize: 500,
        suppressContextMenu: true
        // onRowClicked: (params) => {
        //   this.highlight(params, 1)
        // },
        // getRowStyle: (params) => {
        //   return this.setRowColor(params)
        // }
      },
      externalColumnDefs: [],
      externalData: [],
      internalGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: false,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        paginationPageSize: 500,
        suppressContextMenu: true
        // onRowClicked: (params) => {
        //   this.highlight(params, 2)
        // },
        // getRowStyle: (params) => {
        //   return this.setRowColor(params)
        // }
      },
      internalColumnDefs: [
        {
          headerName: this.$t('Clearing.BusinessNumber'),
          field: 'jobNo',
          width: 100,
          cellStyle: (params) => {
            return this.setColor(params)
          }
        },
        {
          headerName: 'MBL.NO',
          field: 'mbl',
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params)
          }
        },
        {
          headerName: 'SO NO',
          field: 'sono',
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params)
          }
        },
        {
          headerName: this.$t('Clearing.ShipName'),
          field: 'vessel',
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params)
          }
        },
        {
          headerName: this.$t('Clearing.Voyage'),
          field: 'voyageFlight',
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params)
          }
        },
        {
          headerName: this.$t('Clearing.ContainerNumber'),
          field: 'containerno',
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params)
          }
        },
        {
          headerName: this.$t('Clearing.CostName'),
          field: 'chargeItemName',
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params)
          }
        },
        {
          headerName: this.$t('Clearing.Currency'),
          field: 'currency',
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params)
          }
        },
        {
          headerName: this.$t('Clearing.TaxIncludedPrice'),
          field: 'amount',
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params, 'right')
          },
          cellRenderer: (params) => {
            return (params.data.amount).toFixed(2)
          }
        },
        {
          headerName: this.$t('Clearing.PriceExclusiveOfTax'),
          field: 'excludingTaxAmount',
          hide: true,
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params, 'right')
          },
          cellRenderer: (params) => {
            return params.value.toFixed(2)
          }
        },
        {
          headerName: this.$t('Clearing.TaxRate'),
          field: 'taxRate',
          hide: true,
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params, 'right')
          },
          cellRenderer: (params) => {
            return params.value.toFixed(2)
          }
        },
        {
          headerName: this.$t('Clearing.TaxAmount'),
          field: 'taxAmount',
          hide: true,
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params, 'right')
          },
          cellRenderer: (params) => {
            return params.value.toFixed(2)
          }
        },
        {
          headerName: this.$t('Clearing.Difference'),
          field: 'diffAmount',
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params, 'right')
          },
          cellRenderer: (params) => {
            return (params.data.diffAmount).toFixed(2)
          }
        },
        {
          headerName: this.$t('Clearing.ReconciliationAmount'),
          field: 'billingAmount',
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params, 'right')
          },
          cellRenderer: (params) => {
            return (params.data.billingAmount).toFixed(2)
          }
        },
        {
          headerName: this.$t('Clearing.UnitPrice'),
          field: 'chargeUnitRate',
          hide: true,
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params, 'right')
          },
          cellRenderer: (params) => {
            return (params.data.chargeUnitRate).toFixed(3)
          }
        },
        {
          headerName: this.$t('Clearing.Quantity'),
          field: 'chargeQuantity',
          hide: true,
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params, 'right')
          }
        },
        {
          headerName: this.$t('Clearing.InvoiceNumber'),
          field: 'invoiceNo',
          hide: true,
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params, 'right')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WarehouseNo'),
          field: 'warehouseNo',
          hide: true,
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params, 'right')
          }
        },
        {
          headerName: this.$t('SeaExport.HblNo'),
          field: 'hblNbr2',
          hide: true,
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params, 'right')
          }
        },
        {
          headerName: this.$t('SeaExport.BusinessReferenceNo'),
          field: 'customerRefNo',
          hide: true,
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params, 'right')
          }
        },
        {
          headerName: this.$t('Clearing.ConfirmationStatus'),
          field: 'end',
          width: 150,
          cellRenderer: (params) => {
            return this.internalConfirmStatus(params)
          },
          cellStyle: (params) => {
            return this.setColor(params)
          }
        },
        {
          headerName: this.$t('Clearing.ReconciliationResult'),
          field: 'reconciliationResult',
          width: 150,
          cellStyle: (params) => {
            return this.setColor(params)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReconciliationStatus'),
          field: 'reconciliationState',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.reconciliationStateLabelFunc(params.value)
          },
          cellStyle: (params) => {
            return this.setColor(params)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReconciliationDiffReason'),
          field: 'reconciliationDiffReason',
          width: 160,
          cellStyle: (params) => {
            return this.setColor(params)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChargeCreadBy'),
          field: 'createdBy',
          width: 120,
          cellRenderer: (params) => {
            const username = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            return username === '' ? this.$t('Clearing.System') : username
          },
          cellStyle: (params) => {
            return this.setColor(params)
          }
        }
      ],
      internalData: []
    }
  },
  mounted() {
    this.init()
    this.toQuery()
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onFileView', function(value) {
      const arr = value.split(',')
      context.onFileView(arr[0], arr[1])
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    // 设置行背景色
    // setRowColor(params) {
    //   if (params.node.data.lightMatch === 1) {
    //     return { background: '#6abdff !important' }
    //   } else {
    //     if (params.node.data.id % 2 !== 1) {
    //       return { background: '#FFFFFF !important' }
    //     } else {
    //       return { background: '#F7F7F7 !important' }
    //     }
    //   }
    // },
    // 单击高亮
    // highlight(params, id) {
    //   // 清空上次内部高亮行
    //   this.internalGridOptions.api.forEachLeafNode((node) => {
    //     node.setSelected(false)
    //   })
    //   // 清空上次外部高亮行
    //   this.externalGridOptions.api.forEachLeafNode((node) => {
    //     node.setSelected(false)
    //   })
    //   // 再次点击时，判断本次点击和上次点击是否为同一行，是同一行，则不传高亮参数
    //   if (this.matchCondition !== params.data.matchCondition) {
    //     this.checkDetails(params, id)
    //     this.matchCondition = params.data.matchCondition
    //   } else {
    //     this.checkDetails()
    //   }
    // },
    // 查看文件
    onFileView(value, id) {
      if (id === '1') {
        BuriedPointUtils.Send('Clearing', 'Reconciliation', 'Reconciliation_12')
      }
      if (id === '2') {
        BuriedPointUtils.Send('Clearing', 'Reconciliation', 'Reconciliation_13')
      }
      const url = `${URL.common.findByFileId}/${value}?sessionId=${this.currentSessionId}`
      window.open(url)
    },
    // 返回列表
    toList() {
      this.isShow = false
      this.uuid = ''
      this.internalPaging.pageNum = 1
      this.internalPaging.pageSize = 100
      this.externalPaging.pageNum = 1
      this.externalPaging.pageSize = 100
    },
    // 列表双击查看
    doubleDetails(params) {
      this.uuid = params.data.uuid
      this.checkDetails()
    },
    // 按钮查看
    buttonDetails() {
      const rows = getGridSelected(this.gridOptions)
      if (rows.length > 1) {
        this.$message.warning('请勾选一条记录。')
      } else {
        if (!this.isChecked) {
          this.uuid = this.selectedRows.uuid
        } else {
          this.uuid = rows[0].uuid
        }
        this.checkDetails()
      }
    },
    // 查看详情
    async checkDetails(params, id) {
      BuriedPointUtils.Send('Clearing', 'Reconciliation', 'Reconciliation_14')
      this.loading = getLoading()
      const data = {
        color: this.checkList[0],
        reconciliationHistoryUuid: this.uuid,
        inPageNum: this.internalPaging.pageNum,
        inPageSize: this.internalPaging.pageSize,
        outPageNum: this.externalPaging.pageNum,
        outPageSize: this.externalPaging.pageSize
      }
      // if (typeof params === 'object') {
      //   data.matchCondition = params.data.matchCondition
      //   data.leftOrRightClicks = id
      // } else {
      //   this.matchCondition = ''
      // }
      const res = await queryByreconciliationHistoryUuid(data).finally(() => {
        this.loading.close()
      })
      this.internalTotalAmount = 0
      this.externalTotalAmount = 0
      if (res.ok) {
        // this.internalPaging.pageNum = res.data.inPageNum
        // this.externalPaging.pageNum = res.data.outPageNum
        // 外部金额合计
        const externalCurrency = {}
        const externalAmountList = []
        res.data.outPageReconciliationChargeVoList?.forEach((item, index) => {
          item.id = index
          externalCurrency[item.currency] = externalCurrency[item.currency] || []
          externalCurrency[item.currency].push(item)
        })

        const externalCurrencyName = Object.keys(externalCurrency)
        externalCurrencyName.forEach(item => {
          let amount = 0
          let externalTotal = 0
          externalCurrency[item].forEach((item) => {
            externalTotal++
            amount += Number(item.amount)
          })
          externalAmountList.push({ 'currency': item, 'amount': amount, 'total': externalTotal })
          this.externalAmountList = externalAmountList
        })

        // 内部金额合计
        const internalCurrency = {}
        const internalAmountList = []
        // 对币种进行分类
        res.data.inPageReconciliationChargeVoList?.forEach((item, index) => {
          item.id = index
          internalCurrency[item.currency] = internalCurrency[item.currency] || []
          internalCurrency[item.currency].push(item)
        })

        const internalCurrencyName = Object.keys(internalCurrency)
        internalCurrencyName.forEach(item => {
          let amount = 0
          // 每个币种总共几笔费用
          let internalTotal = 0
          // 计算每个币种的金额
          internalCurrency[item].forEach(item => {
            internalTotal++
            amount += Number(item.amount)
          })
          internalAmountList.push({ 'currency': item, 'amount': amount, 'total': internalTotal })
          this.internalAmountList = internalAmountList
        })
        this.externalData = res.data.outPageReconciliationChargeVoList
        this.internalData = res.data.inPageReconciliationChargeVoList
        this.externalPaging.total = res.data.outTotal
        this.internalPaging.total = res.data.inTotal
        this.externalColumnDefs = []
        this.isShow = true
        res.data.reconciliationTemplateMappingList?.map((item) => {
          switch (item.tableColumnName) {
            case 'MBL':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'mbl',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
            case 'VOYAGE_FLIGHT':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'voyageFlight',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
            case 'VESSEL':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'vessel',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
            case 'CHARGEITEMNAME':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'chargeItemName',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
            case 'AMOUNT':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'amount',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params, 'right')
                },
                'cellRenderer': (params) => {
                  return (params.data.amount).toFixed(2)
                }
              })
              break
            case 'CURRENCY':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'currency',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
            case 'CONTAINERNO':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'containerno',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
            case 'SONO':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'sono',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
            case 'CHARGE_UNIT_RATE':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'chargeUnitRate',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                },
                'cellRenderer': (params) => {
                  return (params.data.chargeUnitRate).toFixed(3)
                }
              })
              break
            case 'CHARGE_QUANTITY':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'chargeQuantity',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
            case 'INVOICENO':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'invoiceNo',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
            case 'JOBNO':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'jobNo',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
            case 'WAREHOUSE_NO':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'warehouseNo',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
            case 'HBL_NBR2':
              this.externalColumnDefs.push({
                'headerName': item.excelColumnName,
                'field': 'hblNbr2',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
            case 'CUSTOMER_REF_NO':
              this.externalColumnDefs.push({
                'headerName': '1',
                'field': 'customerRefNo',
                'width': 150,
                'cellStyle': (params) => {
                  return this.setColor(params)
                }
              })
              break
          }
        })
        this.externalColumnDefs.push({
          'headerName': this.$t('Clearing.ReconciliationResult'),
          'field': 'reconciliationResult',
          'width': 150,
          'cellStyle': (params) => {
            return this.setColor(params)
          }
        })
      }
    },
    // 设置颜色
    setColor(item, right) {
      switch (item.data.color) {
        case 0:
          return { color: '#000000', textAlign: right ? 'right' : '' }
        case 1:
          return { color: '#4B7902', textAlign: right ? 'right' : '' }
        case 2:
          return { color: '#D9001B', textAlign: right ? 'right' : '' }
        case 3:
          return { color: '#F59A23', textAlign: right ? 'right' : '' }
      }
    },
    // 选中列表数据时才允许点击查看
    changed(event) {
      const rows = event.api.getSelectedRows()
      if (rows.length > 0) {
        this.isChecked = true
      } else {
        this.isChecked = false
      }
      this.banned = rows.length
    },
    async init() {
      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.storageURL = cache.config.get('StorageURL')
    },
    fetchOrderRequirement() {
      this.fullscreenLoading = getLoading()
      historyList(this.filter)
        .then((res) => {
          this.filter.total = Number(res.data.total)
          this.rowData = res.data.list
          this.fullscreenLoading.close()
        })
        .catch(() => {
          this.fullscreenLoading.close()
        })
    },
    // 转换内部表格确认状态为对应文本
    internalConfirmStatus(params) {
      if (params.value === 0) {
        return this.$t('CargoMsg.Cargo_Unconfirmed')
      }
      if (params.value === 1) {
        return this.$t('Clearing.Confirmed')
      }
    },
    // 切换筛选
    statusChanges() {
      if (this.checkList.length > 1 && this.checkList.length !== 0) {
        this.checkList.splice(0, 1)
        this.internalPaging.pageNum = 1
        this.internalPaging.pageSize = 100
        this.externalPaging.pageNum = 1
        this.externalPaging.pageSize = 100
        this.checkDetails()
        this.checkedId = this.checkList[0]
      } else {
        this.checkList.push(this.checkedId)
      }
    },
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 查询
    toSimpleQuery() {
      this.filter.tenantId = this.$store.getters.tenantId
      this.fullscreenLoading = getLoading()
      historyList(this.filter).then((res) => this.handleQueryData(res)).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    handleQueryData(res) {
      this.banned = 0
      this.rowData = res.data.list
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.fullscreenLoading.close()
    },
    toAdvancedQuery() {
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.tenantId = this.$store.getters.tenantId
      this.fullscreenLoading = getLoading()
      historyList(this.filterJson).then((res) =>
        this.handleQueryData(res)
      ).catch(() => {
        this.fullscreenLoading.close()
      })
    }
  }
}
</script>
<style lang="scss">
.historical-details{
  height: 100%;
  .instructions{
    margin:0;
    font-size: 14px;
    width: 100%;
    height: 30px;
    border-radius: 4px;
    border: 1px solid #f0f3f8;
    display: flex;
    align-items: center;
    flex-direction: row;
    padding-left: 10px;
    span{
      font-size: 14px;
    }
  }
  .footer-check{
    margin-top: 15px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  .details-list{
    display: flex;
    flex-direction: column;
    .details-content{
      display: flex;
      .left,.right{
        width: 50%;
        border: 1px solid #cccccc;
        border-radius: 5px;
        background: #f0f3f8;
        padding: 0 10px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
      }
      .uniform{
        display: flex;
        justify-content: space-between;
        .combined{
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          justify-content: end;
          .usd{
            padding: 0 5px;
            box-sizing: border-box;
            text-align: right;
            margin: 0;
          }
        }
      }
    }
  }
}
</style>
